import $ from 'jquery';
import run from '../../utilities/run';
import timePicker from "../../components/timePicker";
import _ from "underscore";
import render from "../../utilities/render";
import {toCurrency} from "../../utilities/currency";

import {convertMilitaryToInt} from "../../utilities/general";
import { handleDisplayFor, setElementsFromScope, hide, show, handleDisplayForV2 } from "../../utilities/selectorHelpers";

const wrapperHTML = require("./html/amazonFBAPackageLabelPrint.html");
const quoteResponsePage = require("./html/QuoteResponse.html");
const quoteHtml = require("./html/QuoteResponse.html");
const quoteErrorHtml = require("./html/quoteResponseFailure.html");

const targetSelector = "#amazon-fba-pallet-shipping";

run(targetSelector, (mainEl) => {
  amazonFbaPalletShipping(mainEl);
});

function amazonFbaPalletShipping(mainEl) {

  let palletCount = 0;
  const palletInfo = mainEl.data("pallet-info");
  const viewQuoteURL = mainEl.data("view-quote-url");
  const saveQuoteUrl = mainEl.data("save-quote-url");
  let lowestQuote = null;
  const cancelProcessUrl = mainEl.data("cancel-process");
  const cancelBtnUrl = mainEl.data("cancel-btn");
  let quotes;
  let viewQuoteRequest = {};
  const orderId = mainEl.data("order-id");
  const pkgNumber = mainEl.data("shipment-id");
  const palletId = mainEl.data("pallet-id");
  let pickupStartTimePicker;
  let pickupEndTimePicker;


  const mainHtml = $(render(wrapperHTML,
    {
      pallets: render(" {%= palletID %} ", {
        palletID: getRenderPallets(palletInfo),
        quoteResponsePage: quoteResponsePage
      })
    }
  ));
  function getRenderPallets(palletInfo) {
    const html = require("./html/amazonFBAPalletName.html");
    let resp = "";
    resp = _.map(palletInfo.pallet, (pallet) => {
      return render(html, {
        palletId: pallet.orderPalletId,
        LPNS: getRenderLpns(pallet)
      });
    });
    return resp.join("");
  }
  function getRenderLpns(pallet) {

    const html = require("./html/amazonFBALpns.html");
    let resp = "";
    resp = _.map(pallet.LPN, (LPNS) => {
      return render(html, {
        lpnsName: LPNS.olmLPNNumber,
        product: getRenderProduct(LPNS)
      });
    });
    return resp.join("");
  }
  function getRenderProduct(LPNS) {

    const html = require("./html/amazonFBALineItems.html");
    let resp = "";
    resp = _.map(LPNS.lineItems, (LPNS) => {
      return render(html, {

        lineitem: LPNS.olmItmSku,
        lineitem2: LPNS.olmPackedQty
      });
    });

    return resp.join("");
  }


  const entryEl = $("<div class='entry-point'></div>");
  const mainElement = $(mainHtml);

  const elsPage = {};

  const elementsPageMap = {
    loading: "#loading",
    viewQuote: "#viewQuote",
    pickupTable: "#pickupTable",
    nullResponse: "#nullResponse",
    copyBtn: "#copyBtn",
    quoteResponse: "#quoteResponse",
    submitQuote: "#submitQuote",
    pickupDate: "#pickupDate",
    cancelBtn: "#cancelBtn",
    cancelProcess: "#cancelProcess",
    stackable: ".stackable",
    pickUpDat: ".pickup-date",
    pickUpTimeStart: ".pickup-time-start",
    pickUpTimeEnd: ".pickup-time-end",
    formId: "#master-form",
    lngth: ".length",
    wdth: ".width",
    heght: ".height",
    weght: ".weight",
    fromHours: "#fromhours",
    fromMinutes: "#fromminutes",
    fromSeconds: "#fromseconds",
    toHours: "#tohours",
    toMinutes: "#tominutes",
    toSeconds:"#toseconds",
    parentDivPanel: ".parent-div-panel",
    pickupTimeRangeMessage: ".pickup-time-range-error-message",
  }

  function init() {
    setElements();
    bindElements();
  }

  function bindElements() {
    elsPage.viewQuote.on("click", function (e) {
      e.preventDefault();
      viewQuoteFlow();
    });
    elsPage.copyBtn.on("click", function () {
      copyBtnFlow();
    });
    elsPage.cancelBtn.on("click", function () {
      cancelBtnFlow();
    });
    elsPage.cancelProcess.on("click", function () {
      cancelProcessFlow();
    });
    elsPage.submitQuote.on("click", function () {
      submitQuoteFlow();
    });
  }

  function setElements() {
    setElementsFromScope(elsPage, elementsPageMap, entryEl);
    timePickerComp();
  };

  mainEl.html(entryEl);
  entryEl.append(mainElement);
  setElements();

  function timePickerComp() {
    const date = new Date();
    const singleDatepickerEl = elsPage.pickUpDat;
    singleDatepickerEl.datepicker({
      startDate: date,
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });
    pickupStartTimePicker =  timePicker(elsPage.pickUpTimeStart);
    pickupStartTimePicker.setTimeFromMilitary("09:00");
    pickupEndTimePicker = timePicker(elsPage.pickUpTimeEnd);
    pickupEndTimePicker.setTimeFromMilitary("18:00");
    handleDisplayForV2(elsPage.pickupTimeRangeMessage, !isPickupTimeRangeValid());
  }


  elsPage.nullResponse.hide();
  elsPage.loading.hide();

  function viewQuoteFlow() {
    const isValid = validateForm(elsPage.formId);
    if (isValid) {
      elsPage.viewQuote.hide();
      elsPage.loading.show();
      let amazon = validateFormDetails();
      $.ajax({
        url: viewQuoteURL,
        type: "POST",
        dataType: "json",
        data: {
          amazon: "{ \"carrierQuote\":" + JSON.stringify(amazon) + "}"
        },
        success: function (data) {
          quotes = data;
          elsPage.loading.hide();
          elsPage.viewQuote.show();

          if (data.quotes.length > 0) {
            const cost = data.quotes[0].cost;
            const transit = parseInt(data.quotes[0].transitTime);
            elsPage.quoteResponse.html(render(quoteHtml, {
              transit: transit,
              quote: toCurrency(cost),
              pickUpDate: data.pickupDate
            })
            );
          }
          else {
            elsPage.quoteResponse.html(render(quoteErrorHtml));
          }

        },
        error: function (data) {
          elsPage.loading.hide();
          elsPage.viewQuote.show();
          elsPage.quoteResponse.html(render(quoteErrorHtml));
        }

      })
    }
  }

  function validateForm(formElement) {
    handleDisplayForV2(elsPage.pickupTimeRangeMessage, !isPickupTimeRangeValid());
    let validator, validationOpts;
    validationOpts = {
      debug: true,
      errorPlacement: function (error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      }
    }
    validator = formElement.validate(validationOpts);
    validator.settings.ignore = ":disabled,:hidden";
    if (formElement.valid() && isPickupTimeRangeValid()) {
      return true;
    } else {
      return false;
    }
  }

  function isPickupTimeRangeValid(){
    return convertMilitaryToInt(pickupStartTimePicker.getMilitaryTime()) < convertMilitaryToInt(pickupEndTimePicker.getMilitaryTime());
  }

  function validateFormDetails() {
    let dimensionArray = [];
    let amazon = [];
    let requestObj = {};
    let fromTime = pickupStartTimePicker.getMilitaryTime();
    let toTime = pickupEndTimePicker.getMilitaryTime();
    for (let i = 0; i < palletInfo.pallet.length; i++) {
      let dimensionObj = {};
      dimensionObj.length = elsPage.lngth.eq(i).val();
      dimensionObj.width = elsPage.wdth.eq(i).val();
      dimensionObj.height = elsPage.heght.eq(i).val();
      dimensionObj.weight = elsPage.weght.eq(i).val();
      dimensionObj.stackable = elsPage.stackable.eq(i).val();
      dimensionArray.push(dimensionObj);
    }
    requestObj.pickupDate = elsPage.pickupDate.val();
    requestObj.pickupTimeFrom = fromTime;
    requestObj.pickupTimeTo = toTime;
    requestObj.packageDetails = dimensionArray;
    amazon.push(requestObj);

    return amazon;
  }

  //For showing the first button & hiding the rest
  elsPage.parentDivPanel.hide();
  // mainEl.find(elsPage.parentDivPanel).eq(0).show();
  elsPage.parentDivPanel.eq(0).show();

  //Apply Weight and Dimesions Button
  function copyBtnFlow() {
    let dimensionObj = {};
    dimensionObj.length = elsPage.lngth.val();
    dimensionObj.width = elsPage.wdth.val();
    dimensionObj.height = elsPage.heght.val();
    dimensionObj.weight = elsPage.weght.val();
    dimensionObj.stackable = elsPage.stackable;
    copyData(dimensionObj);
  }

  function copyData(dimensionObj) {
    for (let i = 1; i < palletInfo.pallet.length; i++) {
      elsPage.lngth.eq(i).val(dimensionObj.length);
      elsPage.heght.eq(i).val(dimensionObj.height);
      elsPage.wdth.eq(i).val(dimensionObj.width);
      elsPage.weght.eq(i).val(dimensionObj.weight);
      elsPage.stackable.eq(i).prop("checked", dimensionObj.stackable.prop("checked"));
    }
  }

  function cancelBtnFlow() {
    window.open(cancelBtnUrl.concat('&shipmentNumber=').concat(pkgNumber).concat("&shippingType=LTL"), "_self");
  }

  function submitQuoteFlow() {
    const url = saveQuoteUrl.concat("&quotes=").concat(JSON.stringify(quotes)).concat("&orderId=").concat(orderId).concat("&pkgNumber=").concat(pkgNumber).concat("&palletId=" + palletId);
    let labelWindow = window.open(url, "_self");
  }

  function cancelProcessFlow() {
    window.open(cancelProcessUrl, "_self");
  }

  init();
}



// WEBPACK FOOTER //
// ./src/pages/amazon-fba-order/amazonFBAPalletShipping.js